var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('db-dygraphs',{ref:"dygraph",attrs:{"_updated":_vm._updated,"data":_vm.data,"options":_vm.graphOptions,"dark":_vm.dark,"colorScheme":_vm.colorScheme},on:{"db-event":_vm.handleDbEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }